// extracted by mini-css-extract-plugin
module.exports = {"Container":"Number_Container__2bHcb","selectOverlay":"Number_selectOverlay__3UB0q","custom":"Number_custom__2Gs9_"};